export default __webpack_public_path__ + "static/media/me-icon-bottom-nav-mobile.5e63b67e.webp";